<template>
  <div class="outer_page_content flex_column">
    <my-bread-crumb :breadMenu="breadMenu"></my-bread-crumb>
    <div class="inner_content_page">
      <text-listen
        :itemList="itemList"
        :bookId="bookId"
        :typeId="typeId"
        :gameId="gameId"
        :chapterId="chapterId"
        :gameName="gameName"
        v-if="textType === 'text-listen'"
      ></text-listen>
      <text-speak
        :itemList="itemList"
        :bookId="bookId"
        :typeId="typeId"
        :gameId="gameId"
        :chapterId="chapterId"
        :gameName="gameName"
        v-if="textType === 'text-speak'"
      ></text-speak>
      <preparation
        :itemList="itemList"
        :bookId="bookId"
        :typeId="typeId"
        :gameId="gameId"
        :chapterId="chapterId"
        :gameName="gameName"
        v-if="textType === 'preparation'"
      ></preparation>
      <text-explanation
        :itemList="itemList"
        :bookId="bookId"
        :typeId="typeId"
        :gameId="gameId"
        :chapterId="chapterId"
        :gameName="gameName"
        v-if="textType === 'text-explanation'"
      ></text-explanation>
    </div>
  </div>
</template>

<script>
import { fetchGameTaskInfo } from '@/api/service';
import MyBreadCrumb from '@/components/BreadCrumb';
import TextListen from '@/components/Study/Text/TextListen';
import TextSpeak from '@/components/Study/Text/TextSpeak';
import Preparation from '@/components/Study/Text/Preparation';
import TextExplanation from '@/components/Study/Text/TextExplanation';
export default {
  components: { TextListen, MyBreadCrumb, TextSpeak, Preparation, TextExplanation },

  mounted() {
    console.log(this.$route.params);
    const { textType, bookId, chapterId, typeId, gameId, name } = this.$route.params;
    this.gameName = name;
    this.bookId = bookId;
    this.chapterId = chapterId;
    this.typeId = typeId;
    this.gameId = gameId;
    this.fetchGameInfo(textType);
  },

  data() {
    return {
      textType: '',
      itemList: [],
      bookId: '',
      chapterId: '',
      typeId: '',
      gameId: '',
      gameName: '',
      breadMenu: [
        {
          title: '选择教材',
          path: '/book'
        },
        {
          title: '教材详情',
          isBack: true
        },
        {
          title: '学习详情'
        }
      ]
    };
  },

  methods: {
    fetchGameInfo(textType) {
      fetchGameTaskInfo({
        bookId: this.bookId,
        bookChapterId: this.chapterId,
        typeId: this.typeId,
        gameId: this.gameId
      }).then(response => {
        this.itemList = response.data;
        this.textType = textType;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.outer_page_content {
  .inner_content_page {
    background-color: white;
    flex: 2;
    position: relative;
  }
}
</style>
